/**/
$(document).ready(function () {

    /* прокрутка к блоку с размерами при клике на "Выберите размер" */
    $('#productDetail-chooseSizeForDelivery').on('click', function(e){
        e.preventDefault();

        let href_chooseSize = $(this).attr("href");

        $("html, body").animate({
            scrollTop: $(href_chooseSize).offset().top-100
        }, {
            duration: 370,
            easing: "linear"
        });

        return false;
    });
});
